import { render, staticRenderFns } from "./view-doc.vue?vue&type=template&id=3e56bd66&scoped=true"
import script from "./view-doc.vue?vue&type=script&lang=js"
export * from "./view-doc.vue?vue&type=script&lang=js"
import style0 from "./view-doc.vue?vue&type=style&index=0&id=3e56bd66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e56bd66",
  null
  
)

export default component.exports